export default __webpack_public_path__ + "static/media/mikenedelko.f9c282c2.png";